<div *ngIf="displayBanner" class="environment-banner alert-danger default-environment-banner">
  <div class="container">
    <strong>This is a test environment.</strong> Please proceed to <a href="{{domain}}" rel="noopener noreferrer">{{domain}}</a> and remove all bookmarks or references to this site.
  </div>
</div>

